'use strict';

import _regeneratorRuntime from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import ButtonBasic from '@/components/form/ButtonBasic.vue';
import AppsContainer from '@/components/AppsContainer.vue';
export default {
  name: 'todoComponent',
  components: {
    ButtonBasic: ButtonBasic,
    AppsContainer: AppsContainer
  },
  props: {
    title: {
      type: String,
      "default": 'Talking to'
    }
  },
  mounted: function mounted() {
    this.calculateTodoCounts();
    //todoComponent__title
  },
  data: function data() {
    return {
      closeForm: false,
      totalDone: 0,
      totalNotDone: 0,
      showAddNew: false,
      newTodoText: '',
      dueDate: '',
      dueTime: '',
      notifyMe: false,
      notifyPeriods: [],
      callMe: false,
      callPeriods: [],
      callMessage: '',
      textMe: false,
      textPeriods: [],
      textMessage: '',
      emailMe: false,
      emailPeriods: [],
      emailMessage: '',
      remindMe: false,
      remindPeriods: []
    };
  },
  watch: {
    '$store.state.todos': 'calculateTodoCounts'
  },
  methods: {
    calculateTodoCounts: function calculateTodoCounts() {
      var totalDoneLocal = 0;
      var totalNotDoneLocal = 0;
      for (var i = 0; i < this.$store.state.todos.length; i++) {
        if (this.$store.state.todos[i].done === true) {
          totalNotDoneLocal++;
        } else {
          totalDoneLocal++;
        }
      }
      this.totalDone = totalDoneLocal;
      this.totalNotDone = totalNotDoneLocal;
    },
    openPanel: function openPanel() {
      this.showAddNew = true;
    },
    toggleMainMenu: function toggleMainMenu() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (_this.$store.state.ShowMainMenu) {
                _this.$store.commit('mainMenuClose');
              } else {
                _this.$store.commit('mainMenuOpen');
              }
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    openSidebar: function openSidebar() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.$store.commit('mainMenuOpen');
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    addTodo: function addTodo() {
      if (this.newTodoText && this.newTodoText != '') {
        this.$store.commit('addTodo', {
          text: this.newTodoText,
          done: false,
          dueDate: this.dueDate,
          dueTime: this.dueTime,
          notifyMe: false,
          notifyPeriods: [],
          callMe: false,
          callPeriods: [],
          callMessage: '',
          textMe: false,
          textPeriods: [],
          textMessage: '',
          emailMe: false,
          emailPeriods: [],
          emailMessage: '',
          remindMe: false,
          remindPeriods: []
        });
        this.newTodoText = '';
        this.dueDate = '';
        this.dueTime = '';
        this.notifyMe = false;
        this.notifyPeriods = [];
        this.callMe = false;
        this.callPeriods = [];
        this.callMessage = '';
        this.textMe = false;
        this.showAddNew = false;
      } else {
        this.$store.commit('showSnackbarWarning', 'Enter a todo item first!');
      }
    }
  }
};